import React from "react";
import './Library.scss';
import DataLibraryClient from "./DataLibraryClient/DataLibraryClient";


const Library = (props) => {
   
   const {dispatch} = props;
    //RENDER
    const libraryView = props.libraryView;
    if (libraryView) {
        return (
            <div className="Library">
                <p className="main-header"> Литература</p>
                <DataLibraryClient
                    libraryData={props.libraryData}
                    dispatch={dispatch}
                />
            </div>
        )
    } else return null;
}
export default Library;